export default class FIMenuCustomerViewed {
	viewedType?: any = null;
	viewedDateTime?: any = null;
	videosSeen?: any = null;
	extraInfo?: any = null;
	constructor(init?: FIMenuCustomerViewed) {
		if (init) {
			this.viewedType = init.viewedType;
			this.viewedDateTime = init.viewedDateTime;
			this.videosSeen = init.videosSeen;
			this.extraInfo = init.extraInfo;
		}
	}
	//viewedTypes:
	//Reset = 1,
	//VideoPresentation = 2,
	//PaymentSheet = 3,
	//Paperwork = 4,
	//Presentation = 5,
	//Graph = 6,
	//PaymentSheetPreferredCoverage = 7,
	//PaymentSheetPaymentStart = 8,
	//PaymentSheetCarousel = 9,
	//AllVideos = 10,
	//PaymentSheetPrinted = 11,
	//FirstVideoViewed = 12,
	//VideosSeen = 13
}
